import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  IconButton,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch } from "react-redux";
import {
  updateInverterSerial,
  removeInverter,
} from "../../../../store/slices/pva_testReport.slices";
import MPPTAccordion from "./mpptAcc";

const InverterAccordion = ({ inverter, inverterIndex, errors }) => {
  const dispatch = useDispatch();

  return (
    <Accordion sx={{ maxWidth: "500px", margin: "0 auto" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pr: 1,
        }}
      >
        {/* 🔹 Expandable Header */}
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ flexGrow: 1 }}>
          <Typography variant="h6">{inverter.name}</Typography>
        </AccordionSummary>

        {/* 🗑️ Delete Button (outside of AccordionSummary to avoid nested button issue) */}
        <IconButton
          color="error"
          onClick={(e) => {
            e.stopPropagation(); // prevent accordion toggle
            dispatch(removeInverter(inverterIndex));
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Box>

      <AccordionDetails>
        {/* 🔹 Serial number input */}
        <TextField
          label="Inverter Serial No.*"
          value={inverter.serialNo}
          onChange={(e) =>
            dispatch(
              updateInverterSerial({
                inverterIndex,

                serialNo: e.target.value,
              })
            )
          }
          fullWidth
          size="small"
          sx={{ mb: 2 }}
          error={!!errors.serialNo && !inverter.serialNo.trim()}
          helperText={
            !!errors.serialNo &&
            !inverter.serialNo.trim() &&
            "Serial no is required"
          }
        />

        {/* 🔸 Show MPPTs only if serial number is filled */}
        {inverter.serialNo?.trim() ? (
          inverter.mppts.map((mppt, mpptIndex) => (
            <MPPTAccordion
              key={mpptIndex}
              mppt={mppt}
              inverterIndex={inverterIndex}
              mpptIndex={mpptIndex}
            />
          ))
        ) : (
          <Typography variant="body2" color="text.secondary">
            Enter a serial number to view MPPT sections
          </Typography>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default InverterAccordion;
